import { Api } from './api';
import { REDIRECT_URI, RESET_PASSWORD_PAGE } from './constants';
import { getInstanceConfiguration } from './domain-mapping';

export const client = new Api({
  ...getInstanceConfiguration(),
  redirectUri: REDIRECT_URI,
  resetPasswordPage: RESET_PASSWORD_PAGE,
});
